import { useWatch } from 'react-hook-form';

import { usePartySizeRange } from 'reservations/account/providers/ConfigProvider';

export const useIsBeyondMaxPartySize = () => {
  const partySize = useWatch({
    name: 'partySize'
  });
  const { max } = usePartySizeRange();
  return partySize > max;
};
